import {
  type Action,
  type Computed,
  FilterActionTypes,
  action,
  computed,
} from "easy-peasy";

import DEFAULT_SUBURB from "./default";
import { type LogEffect, createLogEffect } from "../../utils/store";

const logEffect = (property: keyof FilterActionTypes<SuburbModel>) =>
  createLogEffect<SuburbModel>("SUBURB", property, false);

export type SuburbModel = {
  ids: number[];
  idsOnChange: LogEffect<SuburbModel>;
  isDefault: Computed<SuburbModel, boolean>;
  isDefaultOnChange: LogEffect<SuburbModel>;
  set: Action<SuburbModel, number[]>;
  reset: Action<SuburbModel>;
};

const suburbModel: SuburbModel = {
  ids: DEFAULT_SUBURB,
  idsOnChange: logEffect("ids"),
  isDefault: computed((state) => state.ids.length === 0),
  isDefaultOnChange: logEffect("isDefault"),
  set: action((state, payload) => {
    state.ids = payload;
  }),
  reset: action((state) => {
    state.ids = DEFAULT_SUBURB;
  }),
};

export default suburbModel;
